import { library, icon } from "@fortawesome/fontawesome-svg-core";

import { faCaretDown, faCaretUp } from "@fortawesome/pro-solid-svg-icons";

import { faCircleNotch, faKey, faSync } from "@fortawesome/pro-regular-svg-icons";

import {
  faEye,
  faQuestionCircle,
  faMinus,
  faPlus,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
} from "@fortawesome/pro-light-svg-icons";

import { fab, faLinux, faUbuntu } from "@fortawesome/free-brands-svg-icons";

/** Add Solid Icons **/
library.add(faCaretDown, faCaretUp);

/** Add Regular Icons **/
library.add(faCircleNotch, faKey, faSync);

/** Add light Icons **/
library.add(faEye, faQuestionCircle, faMinus, faPlus, faChevronLeft, faChevronRight, faChevronDown);

/** Add brand Icons **/
library.add(fab, faLinux, faUbuntu);

export default library;

export function check_icon_imported(is) {
  return icon({ prefix: is[0], iconName: is[1] }) !== undefined;
}
